import styled from "styled-components";
import { Button, TableCell, TableRow } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

export const StyledTableRow = styled(TableRow)`
    border-bottom: 0;

    * {
        vertical-align: middle;
    }

    .typeIcon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }

    &.mainRow {
        border-bottom: 1px solid var(--color-grey-500);
        th {
            color: var(--color-secondary);
        }

        font-size: var(--font-size-16);
    }

    &.secondaryRow {
        border-bottom: 1px solid var(--color-grey-500);
        th {
            padding-left: 64px;
        }
        font-size: var(--font-size-14);
    }
`;

export const StyledTableCell = styled(TableCell)`
    color: var(--color-grey-900);
    padding: 12px 16px;
    cursor: default;
`;

export const StyledSignButton = styled(Button)`
    &.button-root.button-root {
        height: 32px !important;
        min-height: 32px !important;
        min-width: 75px !important;
        @media ${breakpoints.xs} {
            font-size: var(--size-14);
        }
    }
`;
